export const GET_PLC_SAFETY_DASHBOARD_STATS = 'GET_PLC_SAFETY_DASHBOARD_STATS';
export const GET_PLC_SAFETY_DASHBOARD_STATS_SUCCESS = 'GET_PLC_SAFETY_DASHBOARD_STATS_SUCCESS';
export const GET_PLC_SAFETY_DASHBOARD_STATS_ERROR = 'GET_PLC_SAFETY_DASHBOARD_STATS_ERROR';
